<style scoped lang="less">
.census {
  width: 100%;
  height: 100%;
  height: auto;
  background-image: url('http://cdn-cus.weixinhai.net/cdn/web/img/bg.da129660.png');
  background-size: 100% 100%;
}

.census-container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  padding-top: 90px;
  padding-bottom: 70px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.census-title {
  font-size: 48px;
  font-family: Source Han Sans CN;
  font-weight: 500;
  color: #FFFFFF;
  line-height: 32px;
  text-shadow: 0px 0px 35px #1745AA;
}

.census-text {
  margin-top: 30px;
  font-size: 36px;
  font-family: SourceHanSansCN-Light;
  color: #FFFFFF;
  line-height: 32px;
}

.census-button {
  text-align: center;
  line-height: 50px;
  border: 0;
  outline: none;
  cursor: pointer;
  width: 190px;
  height: 50px;
  font-size: 18px;
  background-color: #2368dd;
  color: white;
  margin-top: 60px;
}

@media (max-width: 1200px) {
  .census-container {
    width: 100%;
  }

  .census-item {
    flex-wrap: wrap;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
  }
}

@media (max-width: 480px) {
  .census-item {
    padding-top: 69px;
  }

  .census-container {
    padding-top: 60px;
    padding-bottom: 60px;
  }

  .census-title {
    width: 80%;
    text-align: center;
    font-size: 18px;
  }

  .census-text {
    width: 50%;
    margin-top: 10px;
    font-size: 14px;
  }

  .census-button {
    margin-top: 30px;
  }
}
</style>
<template>
  <div class="census" id="censusId">
    <div class="census-container">
      <p :class="['census-title', {'animated fadeInUp': flag}]">{{ $t('Census.title') }}</p>
      <p :class="['census-text', {'animated fadeInUp': flag}]">{{ $t('Census.text') }}</p>
      <a href="Product.html">
        <button class="census-button">{{ $t('Census.button') }}</button>
      </a>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Census.vue',
  components: {},
  data() {
    return {
      flag: true,
      interTimer: null
    }
  },
  mounted() {
  },
  destroyed() {
  }
}
</script>
